export default __webpack_public_path__ + "static/media/brand-icons.6729d297.svg";